import React, { useState, useRef } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { setCurrentLang } from "../../../store/actions/Lang";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../routes/History";
import logo from "../../../assets/images/0-01.png";
import "./Navbar.scss";
import { candidatesPortalLink, updateURLocalization } from "utils/Shared";

function Navbars(props) {
  const lang = useSelector((state) => state.locale.lang);
  const { messages } = props.intl;
  const dispatch = useDispatch();
  const switcher = (lang) => {
    updateURLocalization(lang === "ar" ? "en" : "ar");
    dispatch(setCurrentLang(lang === "ar" ? "en" : "ar"));
  };
  const [navBg, setNavBg] = useState(false);
  const atHome = useRef(history.location.pathname === "/");

  function debounce(cb, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }
  const changeBG = debounce(() => {
    if (window.scrollY > 0) {
      setNavBg(true);
    } else {
      setNavBg(false);
    }
  }, 50);

  if (atHome.current) {
    window.addEventListener("scroll", changeBG);
  }
  return (
    <React.Fragment>
      <Navbar
        expand="lg"
        className={`nav_container py-1 ${
          navBg || !atHome.current ? `background` : ""
        }`}
      >
        <Container className="nav-container-width container-fluid">
          <Link to="/">
            <img src={logo} alt="HRCom logo" className="navbar-logo p-1" />
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav
              className="d-flex align-items-center links"
              activeKey={history.location.pathname}
            >
              <Nav.Item>
                <Nav.Link
                  href="/"
                  className="navItem semi_bold_font link"
                  data-lang={lang}
                >
                  {messages.home}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  href="/About-us"
                  className="navItem semi_bold_font link"
                  data-lang={lang}
                >
                  {messages.aboutUs}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  href="/products"
                  className="navItem semi_bold_font link"
                  data-lang={lang}
                >
                  {messages.products}
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link
                  href="/pricing"
                  className="navItem semi_bold_font link"
                  data-lang={lang}
                >
                  {messages.pricing}
                </Nav.Link>
              </Nav.Item> */}

              <Nav.Item>
                <Nav.Link
                  href="/Contact-us"
                  className="navItem semi_bold_font link"
                  data-lang={lang}
                >
                  {messages.contactUs}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  href="/blogs"
                  className="navItem semi_bold_font link"
                  data-lang={lang}
                >
                  {messages.blogs}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  href="https://jobseeker.hrcom.io/?locale=en"
                  className="navItem semi_bold_font link"
                  data-lang={lang}
                >
                  {messages.buttons.jobSeeker}
                </Nav.Link>
              </Nav.Item>
            </Nav>

            {history.location.pathname === "/registration" ? (
              ""
            ) : (
              <Nav>
               <Link
                  className="signNav text-white navItem px-3  medium_font mx-0"
                  to="/registration"
                >
                  <button className="text-white text-uppercase signNav btn-primary text-uppercase px-4 py-2 bold_font try-btn">
                    {messages.tryFree}
                  </button>
                </Link>
              </Nav>
            )}
          </Navbar.Collapse>
          {(history.location.pathname === "/registration" ||
            history.location.pathname === "/request-demo") && (
            <div className="log-lang d-flex">
              <Nav className="navItem text-dark bold_font">
                <Link
                  className="signNav bold_font navItem px-1 mx-0"
                  to="/companyLogin"
                >
                  {messages.signIn}
                </Link>
              </Nav>
            </div>
          )}
          {(() => {
            if (
              history.location.pathname === "/companyLogin" ||
              history.location.pathname === "/registration" ||
              history.location.pathname === "/request-demo"
            ) {
              return "";
            } else {
              return (
                <>
                  <div className="log-lang d-flex">
                    <Nav className="navItem text-dark bold_font login_dropdown">
                      {/* <Link
                      className="signNav bold_font navItem px-1 mx-0"
                      to="/companyLogin"
                    >
                      {messages.signIn}
                    </Link> */}
                      <NavDropdown
                        title={messages.signIn}
                        id="basic-nav-dropdown"
                      >
                        <a
                          className=" dropdown-item"
                          href="https://jobseeker.hrcom.io/?locale=en"
                        >
                          {messages.buttons.jobSeeker}
                        </a>

                        <NavDropdown.Divider />
                        <Link className=" dropdown-item" to="/companyLogin">
                          {messages.shared.company}
                        </Link>
                      </NavDropdown>
                    </Nav>
                    <div className="border_right bold_font"></div>
                    <Nav.Link className="text-center nav-link d-flex align-items-center justify-content-center p-1 pb-2">
                      <button
                        className={`btn btn-link langBtn ${
                          lang === "ar" ? "arrow-en" : ""
                        } `}
                        id="en"
                        onClick={() => switcher(lang)}
                      >
                        {messages.langBtn}
                      </button>
                    </Nav.Link>
                  </div>
                </>
              );
            }
          })()}
        </Container>
      </Navbar>
    </React.Fragment>
  );
}

const HeaderComponent = injectIntl(Navbars);

export default HeaderComponent;
